import React, { useState, useRef } from 'react';
import { Send } from 'lucide-react';

/**
 * Chat input bar.
 * Submits on Enter (without Shift) or clicking the send button.
 */
const ChatInput = ({ onSend, disabled }) => {
  const [text, setText] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setText('');
    inputRef.current?.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="chatbot-input-bar">
      <input
        ref={inputRef}
        type="text"
        className="chatbot-input-field"
        placeholder="Ask TrueFace AI…"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        aria-label="Chat message input"
      />
      <button
        className="chatbot-send-btn"
        onClick={handleSubmit}
        disabled={disabled || !text.trim()}
        aria-label="Send message"
      >
        <Send size={16} strokeWidth={2} />
      </button>
    </div>
  );
};

export default ChatInput;
